import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activities-activities',
  templateUrl: './activities-activities.component.html',
  styleUrls: ['./activities-activities.component.scss']
})
export class ActivitiesActivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
